import styled from 'styled-components'

export const NOCWrapper = styled.form`
  padding-top: 23px;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 88vh;

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    height: 600px;
  }

  .blur {
    background-color: #6e7191;
    opacity: 1;
  }
  .minus {
    margin-top: 0px;
  }
  h1 {
    font-family: inter;
    font-style: normal;
    font-weight: 500;
    font-size: ${({ theme }) => theme.fontSize.x1};
    line-height: 32px;
  }
  h6 {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.DarkCyan};
    margin-top: -5px;
  }
  input {
    margin-top: -20px;
  }
  .amount {
    margin-bottom: 30px;
  }
`
export const FormContainer = styled.div`
  .form-group {
    position: relative;
    margin-bottom: 25px;
  }

  .form-group.has-error input {
    border: 1px solid red;
  }

  .form-group.has-error .error-icon {
    display: block;
  }

  .error-icon {
    position: absolute;
    top: 0px;
    right: 7px;
    font-size: 24px;
    display: none;
    color: red;
  }
  .minus {
    margin-top: -20px;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      margin-top: -15px;
    }
  }

  .error-text {
    text-align: left;
    margin: 0 26px;
    padding-top: 4px;
    text-transform: capitalize;
    color: red;
    font-size: ${({ theme }) => theme.fontSize.s};
  }

  .form-group input:focus {
    border: 1px solid blue;
  }
`
